import React from 'react';
import {Container, Toast} from 'react-bootstrap';

interface beneficioUp {
    id: number;
    titulo: string;
    descripcion: string;
    url: string;
    vigencia: Date;
    logo_empresa?: string;
    status: string;
    nombre_empresa: string;
    imagen: string;
    created_at: Date;
    contacto: string;
}

interface beneficioUpProp {
    beneficios: beneficioUp[];
}

const API_URL = process.env.REACT_APP_API_URL;

const BeneficiosUp: React.FC<beneficioUpProp> = ({beneficios}) => {
    const loopedBeneficios = [...beneficios, ...beneficios];
    return (
        <Container style={{height: '100%', overflow: 'hidden', position: 'relative'}}>
            <div className="scroll-content">
                {loopedBeneficios.map((beneficio, index) => (
                    <div className="pt-2" key={index}>
                        <Toast className="w-100">
                            <Toast.Header closeButton={false}>
                                <strong className="me-auto">{beneficio.nombre_empresa} | {beneficio.titulo}</strong>
                                <small>{`Vigencia: ${new Date(beneficio.created_at).toLocaleDateString()}`}</small>
                            </Toast.Header>
                            <Toast.Body>{beneficio.descripcion}</Toast.Body>
                        </Toast>
                    </div>
                ))}
            </div>
        </Container>
    );
}

export default BeneficiosUp;